import { useState } from "react";
import { motion } from "framer-motion";
import { ChevronLeftIcon, ChevronRightIcon, EyeIcon } from "lucide-react";
const CONTENT_PREVIEWS = [{
  src: "https://cdn.magicpatterns.com/uploads/wRDaBZst9oJzqMHZWmAVY6/Screenshot_2026-07-26_at_11.05.56_PM.png",
  alt: "Contenido del kit sobre confianza específica y global"
}, {
  src: "https://cdn.magicpatterns.com/uploads/pwhG7UszJNLLGahTwgaa69/Screenshot_2026-07-26_at_11.06.07_PM.png",
  alt: "Contenido del kit sobre el síndrome del impostor deportivo"
}, {
  src: "https://cdn.magicpatterns.com/uploads/wsLLxkMF9Lu7zbL5u3J6di/Screenshot_2026-07-26_at_11.06.15_PM.png",
  alt: "Contenido del kit sobre cómo filtrar feedback útil"
}, {
  src: "https://cdn.magicpatterns.com/uploads/oiJMDNgenpLpEbuEFMkfSn/Screenshot_2026-07-26_at_11.06.35_PM.png",
  alt: "Contenido del kit con plantilla del banco de confianza"
}];
export function ContentPreview() {
  const [activeIndex, setActiveIndex] = useState(0);
  const goToPreview = (index: number) => {
    setActiveIndex((index + CONTENT_PREVIEWS.length) % CONTENT_PREVIEWS.length);
  };
  const handleDragEnd = (_: MouseEvent | TouchEvent | PointerEvent, info: {
    offset: {
      x: number;
    };
  }) => {
    if (info.offset.x < -45) goToPreview(activeIndex + 1);
    if (info.offset.x > 45) goToPreview(activeIndex - 1);
  };
  return <section className="px-5 pt-10" aria-label="Vista previa del contenido" data-id="element-63" data-mp="283hpbtor12xh">
      <p className="mx-auto max-w-sm text-center text-xl font-black leading-snug text-blue-950" data-id="element-64" data-mp="285kp35fpeafe">
        Llevas años entrenando el cuerpo. Es hora de entrenar lo único que
        realmente decide el resultado.
      </p>

      <div className="mt-9 flex items-center justify-center gap-2 text-blue-700" data-id="element-65" data-mp="2d342k34kuj6a">
        <EyeIcon size={19} aria-hidden="true" data-id="element-66" data-mp="nnwhlbs87p6w" />
        <h2 className="text-lg font-extrabold" data-id="element-67" data-mp="nopg5ph178dy">Échale un vistazo al contenido</h2>
      </div>

      <div className="relative mt-5" data-id="element-68" data-mp="ipuyiqusvpvf">
        <div className="overflow-hidden rounded-2xl border border-blue-100 bg-white shadow-md" data-id="element-69" data-mp="iqwdh6exswif">
          <motion.div className="flex" animate={{
          x: `-${activeIndex * 100}%`
        }} transition={{
          type: "spring",
          stiffness: 320,
          damping: 32
        }} drag="x" dragConstraints={{
          left: 0,
          right: 0
        }} dragElastic={0.12} onDragEnd={handleDragEnd} data-id="element-70" data-mp="18f1s81p948v5">
            {CONTENT_PREVIEWS.map(preview => <figure key={preview.src} className="w-full flex-none" data-id="element-71" data-mp="1rbbal176rlky">
                <img src={preview.src} alt={preview.alt} className="block h-auto w-full" data-id="element-72" data-mp="1vcd2sy2oqxdf" />
              </figure>)}
          </motion.div>
        </div>

        <button type="button" onClick={() => goToPreview(activeIndex - 1)} aria-label="Ver contenido anterior" className="absolute left-2 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-blue-100 bg-white/95 text-blue-700 shadow-sm transition-colors hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2" data-id="element-73" data-mp="252g3zljynhmu">
          <ChevronLeftIcon size={19} aria-hidden="true" data-id="element-74" data-mp="3pl0fh8dz3qxe" />
        </button>
        <button type="button" onClick={() => goToPreview(activeIndex + 1)} aria-label="Ver siguiente contenido" className="absolute right-2 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-blue-100 bg-white/95 text-blue-700 shadow-sm transition-colors hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2" data-id="element-75" data-mp="3pncvvh431t8c">
          <ChevronRightIcon size={19} aria-hidden="true" data-id="element-76" data-mp="7g6xn3ho37yz" />
        </button>
      </div>

      <div className="mt-4 flex items-center justify-center gap-2" role="tablist" aria-label="Seleccionar vista previa" data-id="element-77" data-mp="14urj3frj7ir7">
        {CONTENT_PREVIEWS.map((preview, index) => <button key={preview.src} type="button" role="tab" aria-selected={activeIndex === index} aria-label={`Ver contenido ${index + 1} de ${CONTENT_PREVIEWS.length}`} onClick={() => goToPreview(index)} className={`h-2.5 rounded-full transition-all focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 ${activeIndex === index ? "w-6 bg-blue-700" : "w-2.5 bg-blue-200 hover:bg-blue-400"}`} data-id="element-78" data-mp="kml1nuuqhsdw" data-mpi={index} />)}
      </div>
    </section>;
}